<template>
    <div>
        <vSelect :options="taskTypeOptions" v-model="taskTypeId" :disabled="disabled" :reduce="option => option.id" label="name"/>
    </div>
</template>

<script>
import scheduledTask from '@/store/system/scheduledTask'
import vSelect from 'vue-select'

export default {
    name: 'ScheduledTaskTypeSelect',
    components: {
        vSelect
    },
    props: {
        value: String,
        disabled: Boolean
    },
    computed: {
        taskTypeOptions: function() {
            var optionList = [];
            for (var taskType of this.$store.state.scheduledTask.taskTypeList) {
                optionList.push({ id: taskType, name: this.$t('scheduled_tasks.type.'+ taskType) })
            }
            return optionList;
        },
        taskTypeId: {
            get: function() { return this.value },
            set: function(newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    created() {
        if (!this.$store.state.scheduledTask) {
            this.$store.registerModule('scheduledTask', scheduledTask);
        }
        this.$store.dispatch('scheduledTask/getTaskTypeList');
    }
}
</script>

<style lang="scss">
    @import 'vue-select/src/scss/vue-select.scss';
</style>